module.exports = __webpack_public_path__ + "static/media/request.6920b84b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/request.svg
// module id = 1286
// module chunks = 1